import CamIcon from "./images/icons/cam.svg?react";
import { useCallback } from "react";
import { useExperiment } from "@/common/hooks/useExperiment";
import { EXPERIMENT_NO_ADS } from "@/common/services/experiment/constants";
import { Button } from "@/components/buttons/Button";
import "./AdSearchLink.scss";

export const AdSearchLink = () => {
  const { isLoading, variant: noAds } = useExperiment({ key: EXPERIMENT_NO_ADS, fallback: false });

  const handleClick = useCallback(() => {
    // eslint-disable-next-line
    window.location.href = "https://ptosrd.com/?siteId=wl3&cobrandId=257522&superCategoryName=&categoryName=&pageName=home&performerName=&prm[psid]=RedGIFs&prm[pstool]=205_1&prm[psprogram]=cbrnd&prm[campaign_id]=&subAffId={SUBAFFID}&prm[utm_source]=search&filters=";
  }, []);

  if (noAds || isLoading) {
    return null;
  }

  return (
    <div className="adSearchLink" onClick={handleClick}>
      <div className="adSearchLinkIcon">
        <CamIcon />
      </div>
      <span className="adSearchLinkText">See more on RG Cams</span>
      <Button className="adSearchLinkBtn" size="xs">RG Cams</Button>
    </div>
  );
};
